<template>
    <section class="steps">
        <div class="text">
            <h2>{{ config.BRIEF_STEPS_TITLE }}</h2>
            <p>{{ config.BRIEF_STEPS_DESCRIPTION }}</p>
        </div>
        <div class="visual">
            <Picture v-if="config.BRIEF_STEPS_IMAGE" :src="config.BRIEF_STEPS_IMAGE" :ratio="16/9" rounded size="cover"/>
            <Video v-else :src="config.BRIEF_VIDEO_URL" rounded/>
        </div>
        <div class="steps">
            <BriefStep v-for="(step, index) in steps" :key="index" :step="step" :order="index + 1"/>
        </div>
        <div class="button">
            <Button v-if="pdf" :color="config.COLOR_PRIMARY" outline>
                <a :href="pdf" target="_blank">{{ config.BRIEF_STEPS_DOWNLOAD }}</a>
            </Button>
        </div>
    </section>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { BriefStep } from '../../components/shared';

export default {
    name: 'BriefSteps',
    components: { BriefStep },
    mixins: [SolutionConsumer],
    props: {
        steps: {
            type: Array,
            required: true,
        },
        video: {
            type: String,
            required: true,
        },
        pdf: {
            type: String,
            default: null,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

section {
    @include brief-section-grid();

    > .text {
        text-align: center;
    }

    > .steps {
        display: grid;
        gap: 16px;
        align-items: flex-start;
    }

    // > .button {
    //     justify-self: center;
    // }

    @include breakpoint-min(lg) {
        // grid-template-rows: auto auto;

        > .text {
            grid-column: 1 / 3;
        }

        // > .button {
        //     justify-self: flex-start;
        // }

        > .steps {
            grid-column: 2 / 3;
            // grid-row: 2 / 4;
            grid-row: 2 / 3;
        }
    }
}
</style>
